"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shim = require("../shim");

var _Story = _interopRequireDefault(require("./Story"));

var Stories =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Stories, _Component);

  function Stories() {
    (0, _classCallCheck2.default)(this, Stories);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Stories).apply(this, arguments));
  }

  (0, _createClass2.default)(Stories, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          kind = _this$props.kind,
          _this$props$storyProp = _this$props.storyProps,
          storyProps = _this$props$storyProp === void 0 ? {} : _this$props$storyProp,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["kind", "storyProps"]);

      var names = _shim._clientAPI.store.getStories(kind);

      if (!names) {
        console.error('unable to find story', {
          kind: kind
        });
        return _react.default.createElement("div", null);
      }

      return _react.default.createElement("div", rest, names.map(function (name) {
        return _react.default.createElement(_react.Fragment, {
          key: name
        }, _react.default.createElement("h2", null, name), _react.default.createElement(_Story.default, (0, _extends2.default)({
          kind: kind,
          name: name
        }, storyProps)));
      }));
    }
  }]);
  return Stories;
}(_react.Component);

exports.default = Stories;
(0, _defineProperty2.default)(Stories, "propTypes", {
  kind: _propTypes.default.string.isRequired
});
//# sourceMappingURL=Stories.js.map